<template>
    <div>
        <div class="index-index-banner">
            <span :class="PrSortIndex==index?'on':''" v-for="(item, index) in ProductSort" :key="index" @click="onGetProductSort(index, item.type)">{{item.name}}</span>
            <span class="border" @click="popupStatus=true"><i>筛选</i><van-icon name="filter-o" size="16" color="#666666"/></span>
        </div>
        <div class="waterfall-height-css">
            <van-list v-model="loading" :finished="finished" finished-text="我们是有底线的" @load="onSearchListLoad">
                <!-- <com-search-product :searchData="searchData.goodsSearchDto.goods.data"></com-search-product> -->
                <comodityItem :goodsList="goodsList" bg-color="background-color:#fff"></comodityItem>
            </van-list>
        </div>
        <!-- <comodityItem  bgColor="background-color:#fff" :loadinging="loading" :goodsList="goodsList" :goodssId="-1" :activeStatus="false" ></comodityItem> -->
        <!-- 设置右滑弹窗 -->
        <van-popup v-model="popupStatus" round position="right">
            <div class="index-index-popup">
                <div class="index-popup-inner">
                    <div class="index-popup-title"><span class="title">价格</span></div>
                    <div class="index-popup-content">
                        <van-field class="input" v-model="searchForm.minPriceFilter" type="digit" placeholder="最低价" />
                        <span>—</span>
                        <van-field class="input" v-model="searchForm.maxPriceFilter" type="digit" placeholder="最高价" />
                    </div>
                </div>
                <div class="index-popup-inner" v-if="filterItemLogos.length>0">
                    <div class="index-popup-title"><span class="title">品牌</span><p @click="itemlogoStatus=!itemlogoStatus">{{itemlogoStatus?'收起':'更多'}}<van-icon :name="itemlogoStatus?'arrow-up':'arrow-down'" size="16"/></p></div>
                    <div class="index-popup-branch">
                        <span :class="[item.checked?'on':'']" v-for="(item, index) in filterItemLogos" :key="index" @click="onGetfilterLogo(item)" v-show="itemlogoStatus?index>=0:index<9">{{item.itemName}}</span>
                    </div>
                </div>
                <div class="index-popup-inner" v-if="filterItemCategory.length>0">
                    <div class="index-popup-title"><span class="title">分类</span><p @click="itemCateStatus=!itemCateStatus">{{itemCateStatus?'收起':'更多'}}<van-icon :name="itemCateStatus?'arrow-up':'arrow-down'" size="16"/></p></div>
                    <div class="index-popup-branch">
                        <span :class="[item.childItems[0].checked?'on':'']" v-for="(item, index) in filterItemCategory" :key="index" @click="onGetfilterCate(item.childItems[0])" v-if="itemCateStatus?index>=0:index<8 && item.childItems.length>0">{{item.childItems[0].itemName}}</span>
                        <span style="margin-right: 0;" @click="secondPopupStatus=true">更多分类 ></span>
                    </div>
                </div>
            </div>
            <div class="index-popup-confirm">
                <van-button class="button" type="default" round @click="onSearchMoreReset()">重置</van-button>
                <van-button class="button confirm" type="warning" round @click="onSearchMoreClick()">确认</van-button>
            </div>
        </van-popup>

        <!-- 右滑二级栏目 -->
        <van-popup v-model="secondPopupStatus" round position="right">
            <div class="index-index-popup">
                <div class="index-popup-header">品类筛选</div>
                <van-collapse v-model="activeNames">
                    <van-collapse-item v-for="(first, index) in filterItemCategory" :key="index" :title="first.itemName" :name="index" value="更多" :show="first.childItems.length>0">
                        <div class="index-popup-branch">
                            <span :class="[second.checked?'on':'']" v-for="(second, index) in first.childItems" :key="'childItems'+index" @click="onGetfilterCate(second)">{{second.itemName}}</span>
                        </div>
                    </van-collapse-item>
                </van-collapse>
            </div>
            <div class="index-popup-confirm">
                <van-button class="button" type="default" round @click="secondPopupStatus=false">取消</van-button>
                <van-button class="button confirm" type="warning" round @click="secondPopupStatus=false">确认</van-button>
            </div>
        </van-popup>
    </div>
</template>

<script>
import http from "@/utils/axios";
import comodityItem from '@/components/commodity/commodity/homeGoodsItem';
export default {
    props: {
        refresh: {
            default: false,
            type: Boolean
        }
    },
    data() {
        return {
            goodsList: [],
            searchType: 'PRODUCT',
            isScreen: 'y',
            searchForm: {minPriceFilter: '', maxPriceFilter: '', logoIdFilters: [], categoryLevelId3Filters: []},
            pageIndex: 0,
            ProductSort: [{name: '综合', type: 'COMPLEX'},{name: '销量', type: 'SALES'},{name: '最新', type: 'NEWEST'}],
            PrSortIndex: 0,
            sortType: '',
            loading: false,
            finished: false,
            popupStatus: false,
            secondPopupStatus: false,
            filterItemLogos: [],
            filterItemCategory: [],
            itemlogoStatus: false,
            itemCateStatus: false,
            activeNames: [0]
        }
    },
    components: { comodityItem },
    methods: {
        onSearchListLoad() {
            this.pageIndex ++ ;
            this.onSearchConfirm()
        },
        onGetProductSort: function (sortIndex, sortType) {
            if (this.PrSortIndex==sortIndex) return false;
            this.pageIndex = 1
            this.PrSortIndex = sortIndex
            this.sortType = sortType
            this.onSearchConfirm()
        },
        onSearchMoreReset: function () {
            this.searchForm = {minPriceFilter: '', maxPriceFilter: '', logoIdFilters: [], categoryLevelId3Filters: []}                        
            this.onSearchMoreClick()
        },
        onSearchMoreClick: function () {
            this.pageIndex = 1;
            this.popupStatus = false
            this.onSearchConfirm()
        },
        onSearchConfirm() {
            let searchParams = {
                pageIndex: this.pageIndex,
                pageSize: 10,
                isScreen: this.isScreen,
                type: this.searchType,
                sort: this.sortType,
                ...this.searchForm
            }
            http({
                url: "search/es/mixed/datasource",
                method: "post",
                parmes: searchParams
            }).then(res => {
                if(res.code == 200) {
                    if(this.pageIndex == 1) {
                        this.goodsList = res.data.productAndDiscovers.data || []
                    } else {
                        this.goodsList =this.goodsList.concat(res.data.productAndDiscovers.data || []);
                    }
                    if(res.data.filterItemLogos) {
                        res.data.filterItemLogos.forEach((item, index) => {
                            item.checked = false
                        })
                        this.filterItemLogos = res.data.filterItemLogos;
                    }
                    if (res.data.filterItemCategory) {
                        res.data.filterItemCategory.forEach((first, firstIndex) => {
                            first.childItems.forEach((second, secondIndex) => {
                                second.checked = false
                            })
                        })
                        this.filterItemCategory = res.data.filterItemCategory
                    }
                    if(!res.data.productAndDiscovers.data||res.data.productAndDiscovers.data.length ==0) {
                        this.finished = true;
                    }
                    this.loading = false
                }
            })
        },
        onGetfilterLogo: function (item) {
            var index = this.searchForm.logoIdFilters.indexOf(item.itemId)
            for (var i = 0; i < this.filterItemLogos.length; i++) {
                if (this.filterItemLogos[i].itemId == item.itemId) {
                    if (this.filterItemLogos[i].checked) {
                        this.filterItemLogos[i].checked = false
                    } else {
                        this.filterItemLogos[i].checked = true
                    }
                }
            }
            if (index > -1) {
                this.searchForm.logoIdFilters.splice(index, 1)
            } else {
                this.searchForm.logoIdFilters.push(item.itemId)
            }
        },
        onGetfilterCate: function (item) {
            var index = this.searchForm.categoryLevelId3Filters.indexOf(item.itemId)
            for (var i = 0; i < this.filterItemCategory.length; i++) {
                for (var j = 0; j < this.filterItemCategory[i].childItems.length; j++) {
                    if (this.filterItemCategory[i].childItems[j].itemId == item.itemId) {
                        if (this.filterItemCategory[i].childItems[j].checked) {
                            this.filterItemCategory[i].childItems[j].checked = false
                        } else {
                            this.filterItemCategory[i].childItems[j].checked = true
                        }
                    }
                }
            }
            if (index > -1) {
                this.searchForm.categoryLevelId3Filters.splice(index, 1)
            } else {
                this.searchForm.categoryLevelId3Filters.push(item.itemId)
            }
        }
    },
    watch: {
        refresh: function(val) {
            if(val) {
                this.onSearchMoreReset()
            }
        }
    }
}
</script>
<style lang="less" scoped>
.waterfall-height-css{
    padding: 20px 20px;
}
.index-index-banner{
    display: flex;
    align-items: center;
    height: 90px;
    background-color: white;
}
.index-index-banner span{
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 37px;
    font-size: 24px;
    color: #999999;
}
.index-index-banner span i{
    font-style: normal;
    padding-right: 15px;
}
.index-index-banner .on{
    color: #333333;
    font-weight: bolder;
}
.index-index-banner .border{
    border-left: 1px solid #dddddd;
}
.index-index-popup{
    display: flex;
    flex-direction: column;
    min-height: calc(100vh - 100px);
    width: 635px;
    padding-top: 100px;
}
.index-popup-inner{
    display: flex;
    flex-direction: column;
    padding: 0 30px 30px;
}
.index-popup-inner.bottom{
    padding-bottom: 0;
}
.index-popup-title{
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 28px;
    padding-bottom: 25px;
    font-weight: bolder;
}
.index-popup-title p{
    display: flex;
    align-items: center;
    font-size: 24px;
    color: #999999;
    padding-right: 5px;
    font-weight: normal;
}
.index-popup-content{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 30px;
}
.index-popup-content .input{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 240px;
    height: 64px;
    border-radius: 32px;
    border: 2px solid #999999;
    text-align: center;
    font-size: 24px;
}
.index-popup-content span{
    font-size: 24px;
    color: #999999;
}
.index-popup-branch span{
    display: inline-block;
    vertical-align: middle;
    width: 141px;
    height: 64px;
    border-radius: 32px;
    border: 2px solid #999999;
    font-size: 24px;
    line-height: 64px;
    text-align: center;
    margin-right: 10px;
    margin-bottom: 30px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 0 20px;
}
.index-popup-branch span:nth-child(3n){
    margin-right: 0;
}
.index-popup-branch .on{
    background-color: #F8D541;
    border-color: #F8D541;
}
.index-popup-header{
    font-size: 32px;
    text-align: center;
    padding-bottom: 30px;
}
.index-popup-confirm{
    position: sticky;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
}
.index-popup-confirm .button{
    margin: 0 15px;
    width: 245px;
    height: 64px;
    line-height: 64px;
}
.index-popup-confirm .confirm{
    background-color: #F8D541;
    color: #333333;
    border-color: #F8D541;
}
</style>